/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Search_Criteria_Label_LocationInputs */

const en_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const fr_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieu`)
};

const es_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const it_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const nl_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locatie`)
};

const pl_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalizacja`)
};

const fi_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sijainti`)
};

const da_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokation`)
};

const sv_jobs_search_criteria_label_location = /** @type {(inputs: Jobs_Search_Criteria_Label_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plats`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Jobs_Search_Criteria_Label_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_search_criteria_label_location = /** @type {((inputs?: Jobs_Search_Criteria_Label_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Search_Criteria_Label_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_search_criteria_label_location(inputs)
	if (locale === "fr") return fr_jobs_search_criteria_label_location(inputs)
	if (locale === "es") return es_jobs_search_criteria_label_location(inputs)
	if (locale === "it") return it_jobs_search_criteria_label_location(inputs)
	if (locale === "nl") return nl_jobs_search_criteria_label_location(inputs)
	if (locale === "pl") return pl_jobs_search_criteria_label_location(inputs)
	if (locale === "fi") return fi_jobs_search_criteria_label_location(inputs)
	if (locale === "da") return da_jobs_search_criteria_label_location(inputs)
	if (locale === "sv") return sv_jobs_search_criteria_label_location(inputs)
	return en_jobs_search_criteria_label_location(inputs)
});